export default __webpack_public_path__ + "static/media/princesa.a98da3b2.png";